<template >
    <div class="container bg-white py-5 px-5" v-if="school && department && program && programYear">
      <h3>{{school.name}} / {{department.name}} / {{program.name}} </h3>
      <p>Чиглэл: {{programYear.name}}</p>
      <p>Зэрэг: {{programYear.degreeName}}</p>
      <p>Хугацаа: {{programYear.duration}} жил</p>
      <p v-if="programYear.startDay">
        Эхлэх хугацаа: 
        {{programYear.startDay.year}}-{{programYear.startDay.month}}- {{programYear.startDay.day}}
      </p>
      <p v-if="programYear.endDay">
        Дуусах хугацаа: 
        {{programYear.endDay.year}}-{{programYear.endDay.month}}- {{programYear.endDay.day}}
      </p>
      <p v-if="programYear.approvedDay">
        Баталсан хугацаа: 
        {{programYear.approvedDay.year}}-{{programYear.approvedDay.month}}- {{programYear.approvedDay.day}}
      </p>
      <p v-if="pros!=null && pros.length>0">Төлөвлөгөөт хичээлийн тоо: {{pros.length}}</p>
      <!-- <p>Нийт кредит: {{programYear.totalCredit}}</p> -->


      <!-- DataTales Example -->
      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Сургалтын төлөвccлөгөөн дэх хичээл</h6>
        </div>
        <div class="card-body" v-if="pros!=null && pros.length>0">
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Хичээл</th>
                  <th>Улирал</th>
                  <th>Кредит</th>
                  <th>Төрөл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(p, index) in pros" v-bind:key="p.id">
                  <td>{{index+1}}</td>
                  <td>
                    <div v-if="p.lesson">
                      {{p.lesson.name}} - {{p.lesson.lectureCode}}
                    </div>
                  </td>
                  <td>
                    {{p.season}}
                  </td>
                  <td>{{p.credit}}</td>
                  <td>
                    <div v-if="p.typeData">
                      {{p.typeData.name}}
                    </div>
                  </td>
      
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "StudentProgramPlan",
    data() {
        return {
          school:null,
          department: null,
          program:null,
          programYear:null,
            pro:{
              season:null,
              credit:null,
              type:null
            },
            pros:[],
            degrees:[],
            seasons:[],
          rootlessons:[]

            
        };
    },
    methods: {
        
      _getQA(){
          fb.db.doc("schools/"+this.schoolId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.school=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/").doc(this.departmentId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.department=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs").doc(this.programId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.program=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs")
            .doc(this.programId)
            .collection("programyears").doc(this.programYearId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.programYear=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId+"/programyears").
          doc(this.programYearId).collection("lessonplan")
          .orderBy("createdAt","desc").get().then(querySnapshot=> {
            this.pros=[];
            querySnapshot.forEach(doc=> {
              let object=doc.data();
              object.id = doc.id;
              object.lesson=null;
              object.typeData=null;
              if(object.rootlesson){
                object.rootlesson.get().then(ldoc=>{
                  if(ldoc){
                    object.lesson=ldoc.data();
                  }
                });
              }
              if(object.type){
                object.type.get().then(ldoc=>{
                  if(ldoc){
                    object.typeData=ldoc.data();
                  }
                });
              }
					    this.pros.push(object);
            });
            
          });

      },


    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        schoolId: { 
            required: true,
        },
        departmentId: { 
            required: true,
        },
        programId:{
          required:true
        },
        programYearId:{
          required:true
        }
    },
    created() {
        var _this=this;
        for(var i=1;i<=12;i++){
          this.seasons.push(i);
        }

        if(this.schoolId!=null && this.schoolId!='' && this.departmentId!=null && this.departmentId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

